import { createSlice } from '@reduxjs/toolkit';
import { set } from 'react-hook-form';

const initialState = {
    title: '메뉴',
    showHeader: true,
    showMenu: true,
    showBack: false,
    showBackBlack: false,
    onBack: null,
    showSubHeader: true,
    showLogout: false,
    appLoading: false,
    alertCheckout: false,
};

const headerSlice = createSlice({
    name: 'header',
    initialState,
    reducers: {
        setTitle: (state, action) => {
            state.title = action.payload;
        },
        setShowHeader: (state, action) => {
            state.showHeader = action.payload;
        },
        setShowMenu: (state, action) => {
            state.showMenu = action.payload;
        },
        setShowBack: (state, action) => {
            state.showBack = action.payload;
        },
        setShowBackBlack: (state, action) => {
            state.showBackBlack = action.payload;
        },
        setOnBack: (state, action) => {
            state.onBack = action.payload;
        },
        onBack: (state) => {
            state.onBack();
        },
        setShowSubHeader: (state, action) => {
            state.showSubHeader = action.payload;
        },
        setShowLogout: (state, action) => {
            state.showLogout = action.payload;
        },
        setAppLoading: (state, action) => {
            state.appLoading = action.payload;
        },
        setAlertCheckout: (state, action) => {
            state.alertCheckout = action.payload;
        },
    },
});

export const { setTitle, setShowHeader, setShowMenu, setShowBack, setOnBack, onBack, setShowSubHeader, setShowBackBlack, setShowLogout, setAppLoading, setAlertCheckout } = headerSlice.actions;
export default headerSlice.reducer;